import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useContext, useEffect, useState, useCallback, useRef } from 'react';
// import { VariableSizeList } from 'react-window';
// https://codesandbox.io/s/react-chat-simulator-yg114?file=/src/ChatRoom/Room/Messages/Messages.js:1692-1696

/* ROUTES */
import * as routes from '../../../routing/routes';
import { get_rev_short, get_rank } from '../master/manageThemes/exportExcel';
/* CONTEXT */
import { FirebaseContext, FirebaseDataContext, ReviewersListContext } from '../../../firebase';

/* MATERIAL */
import { withStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import CircularProgress from '@mui/material/CircularProgress';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import TrafficIcon from '@mui/icons-material/Traffic';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';

import { colorStyles } from '../utils';
import { APP_YEAR } from "../../../constants";

const reviewerSpecProjectStyles = makeStyles((theme) => ({
  pageTitle: {
    fontSize: '1.6rem',
    color: theme.palette.primary.main,
    fontWeight: 500,
    marginBottom: 20,
  },
  projectBy: {
    fontSize: '1rem',
    color: '#333',
    fontWeight: 500,
    marginBottom: 30,
  },
  projectCategoryAndTheme: {
    fontStyle: 'italic',
    fontSize: '.9rem',
    marginBottom: 20,
  },
  saveContainer: {
    position: 'sticky',
    bottom: 0,
    background: 'white',
    // width: '100%',
    textAlign: 'center',

    transform: 'scaleY(0)',
    transformOrigin: 'bottom',
    transition: 'transform 200ms ease-in-out',
    pointerEvents: 'none',
    height: 0,
    padding: 0,
  },
  showSave: {
    height: 'auto',
    padding: 50,
    transform: 'scaleY(1)',
    pointerEvents: 'all',
    borderTop: '1px solid ' + theme.palette.primary.main,
  },
  closePaper: {
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: 30,
    borderRadius: 5,
  },
  closeContainer: {
    textAlign: 'center',
    height: 'auto',
    padding: 30,
  },
  projectFilesAccordion: {
    marginTop: 20,
    marginBottom: 20,
  },
  projectFilesAccordionSummary: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    '& .MuiAccordionSummary-expandIconWrapper': {
      color: 'white',
    },
  },
  projectFilesAccordionDetails: {
    flexDirection: 'column',
  },
  projectFilesAccordionDetailsBox: {
    paddingTop: 10,
    paddingBottom: 10,
  },
  scorePaper: {
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: 30,
    borderRadius: 5,
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  },
  scoreTitle: {
    fontSize: '1.2rem',
    fontWeight: 700,
  },
  score: {
    fontSize: '2rem',
    fontWeight: 700,
  },
  green: {
    color: theme.palette.secondary.main,
  },
  blue: {
    color: theme.palette.primary.main,
  },
  orange: {
    color: theme.palette.warning.main,
  },
  red: {
    color: theme.palette.error.main,
  },
}));

export const ReviewerSpecProject = (props) => {
  const classes = reviewerSpecProjectStyles();
  const { projectId } = useParams();
  const colors = colorStyles();

  const firebaseDataContext = useContext(FirebaseDataContext);
  const firebaseContext = useContext(FirebaseContext);
  const reviewersListContext = useContext(ReviewersListContext);

  const location = useLocation();
  const navigate = useNavigate();

  const evaluationForm = useRef();

  const isGlobal = props.global || false;

  const [downloading, setDownloading] = useState(false);
  const [downloadingFile, setDownloadingFile] = useState({});

  const aapId = ((firebaseDataContext.userProjects || {})[projectId] || { status: {} }).status.aap_id || null;

  const { themeName } = location.state || { themeName: null };

  useEffect(() => {
    if (themeName == null) {
      navigate(routes.ADMIN, { replace: true });
    }
    if (!firebaseDataContext.definitions || !firebaseDataContext.definitions[aapId]) {
      /* aapId not found */
      navigate(routes.ADMIN, { replace: true });
    } else if (!firebaseDataContext.userProjects || !firebaseDataContext.userProjects[projectId]) {
      /* projectID not found */
      navigate(routes.ADMIN, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aapId, themeName]);

  const [submittingEvaluation, setSubmittingEvaluation] = useState(false);

  /* initialized evaluation */
  const [evaluationStateApplied, setEvaluationStateApplied] = useState(false);
  const [currentEvaluation, setCurrentEvaluation] = useState({});

  const [evaluationState, setEvaluationState] = useState({});

  // non global effect (ie reviewer)
  useEffect(() => {
    if (isGlobal) return;
    if (firebaseDataContext.evaluations) {
      setCurrentEvaluation({
        ...(firebaseDataContext.evaluations[projectId] || {}),
      });

      setEvaluationState({
        ...(firebaseDataContext.evaluations[projectId] || {}),
      });

      setEvaluationStateApplied(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firebaseDataContext.evaluationsRead]);

  // global effect (ie theme admin)
  useEffect(() => {
    if (!isGlobal) return;

    if (firebaseDataContext.evaluationsGlobales) {
      setCurrentEvaluation({
        ...(firebaseDataContext.evaluationsGlobales[projectId] || {}),
      });

      setEvaluationState({
        ...(firebaseDataContext.evaluationsGlobales[projectId] || {}),
      });

      setEvaluationStateApplied(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firebaseDataContext.evaluationsGlobalesRead]);

  const getFormEntries = () => {
    const formData = new FormData(evaluationForm.current);
    const formEntries = Object.fromEntries(formData);

    for (const inputName in formEntries) {
      if (inputName.startsWith('[CN]')) {
        formEntries[inputName.substring(4)] = +formEntries[inputName];
        delete formEntries[inputName];
      }

      if (formEntries[inputName] === 'true') formEntries[inputName] = true;
      if (formEntries[inputName] === 'false') formEntries[inputName] = false;
    }
    return formEntries;
  };

  const [stateEqualCurrentEvaluation, setStateEqualCurrentEvaluation] = useState(true);
  useEffect(() => {
    const checkInterval = setInterval(() => {
      const formEntries = getFormEntries();
      let isEqual = true;

      for (let k in formEntries) {
        if (k === 'status') continue;
        if (!(k in currentEvaluation) && formEntries[k]) {
          isEqual = false;
          break;
        }

        if (formEntries[k] !== (currentEvaluation[k] ?? '')) {
          isEqual = false;
          break;
        }
      }

      if (isEqual !== stateEqualCurrentEvaluation) {
        setStateEqualCurrentEvaluation(isEqual);
      }
    }, 500);
    return () => {
      clearInterval(checkInterval);
    };
  });

  const goBackToList = () => {
    if (isGlobal) {
      navigate(routes.ADMIN + routes.GLOBAL_EVALUATION);
    } else {
      navigate(routes.ADMIN + routes.EVALUATION);
    }
  };

  /* form change events */
  const handleEvaluationChange = useCallback(({ target }, parent) => {
    // console.log('handel eval change');
    const { value, name } = target;
    setEvaluationState((prevState) => {
      return { ...prevState, [name]: value };
    });

    if (target.tagName === 'TEXTAREA' && parent) {
      // window.scrollTo(target);
      const parentBBox = parent.current.getBoundingClientRect();

      const topLimit = 180;
      if (parentBBox.top !== topLimit) {
        props.containerRef.current.scrollBy(0, parentBBox.top - topLimit);
      }
    }
  }, [props.containerRef]);

  // const handleEvaluationChange = useRef(({ target }) => {
  //   const { value, name } = target;
  //   // console.log('handle change ', name, value);
  //   setEvaluationState((prevState) => {
  //     return { ...prevState, [name]: value };
  //   });
  // });

  const [expanded, setExpanded] = useState(false);

  /* Early return when not yet read */
  if ((!firebaseDataContext.evaluationsRead && !isGlobal) || !firebaseDataContext.themesRead || !firebaseDataContext.projectsRead || !firebaseDataContext.evaluation_flagRead) {
    return (
      <Grid container direction="row" justifyContent="center" alignItems="center" style={{ minHeight: '100%' }}>
        <CircularProgress thickness={6} size={50} />
      </Grid>
    );
  }

  const evaluationFlag = firebaseDataContext.evaluation_flag;
  const evaluationQuestions = (firebaseDataContext.evaluationDefinitions[evaluationFlag] || {}).evaluationQuestions || [];
  const evaluationParameters = (firebaseDataContext.evaluationDefinitions[evaluationFlag] || {}).evaluationParameters || {};

  const projectData = firebaseDataContext.userProjects[projectId] || { data: {}, status: {} };

  // const stateEqualCurrentEvaluation = () => {
  //   // const formEntries = getFormEntries();
  //   for (let k in evaluationState) {
  //     // for (let k in formEntries) {
  //     // if (k === 'status') continue;
  //     if (!(k in currentEvaluation)) return false;
  //     if (evaluationState[k] !== currentEvaluation[k]) return false;
  //     // if (formEntries[k] !== currentEvaluation[k]) {
  //     //   console.log('found diff', k);
  //     //   return false;
  //     // }
  //   }
  //   return true;
  // };

  const submitEvaluation = (closing = false) => {
    // const formData = new FormData(evaluationForm.current);
    // const formEntries = Object.fromEntries(formData);
    // console.log(evaluationForm.current, formEntries);
    // return;

    // console.log(evaluationState);
    // return;
    setSubmittingEvaluation(true);

    // const evaluationToSubmit = { ...evaluationState };
    const evaluationToSubmit = getFormEntries();
    // console.log(evaluationToSubmit)
    if (closing) {
      evaluationToSubmit[evaluationFlag] = true;
    }

    const setEvalFunc = isGlobal ? firebaseContext.app.setGlobalEvaluation : firebaseContext.app.setEvaluation;

    setEvalFunc(firebaseContext.user.uid, projectId, evaluationToSubmit).then(
      (written) => {
        setCurrentEvaluation({
          ...evaluationToSubmit,
        });
        setEvaluationState({ ...evaluationToSubmit });
        setSubmittingEvaluation(false);
        setStateEqualCurrentEvaluation(true);
      },
      (error) => {
        console.error(error);
        setSubmittingEvaluation(false);
      }
    );
  };

  const setEvaluationClose = () => {
    submitEvaluation(true);
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // download project pdf
  const downloadProjectPDF = () => {
    setDownloading(true);

    firebaseContext.app.downloadProjectPDF(projectData.status).then(
      () => {
        setDownloading(false);
      },
      (error) => {
        console.error('While downloading projet pdf', error);
        setDownloading(false);
      }
    );
  };

  const downloadFile = (fileref, fileid) => {
    setDownloadingFile((prevDown) => ({
      ...prevDown,
      [fileid]: true,
    }));

    const downloadFilename = `ASK_${APP_YEAR}_${fileid}_${projectId}`;
    //${firebaseDataContext.definitions[aapId].name_fr.replace(' ', '_')}

    firebaseContext.app.downloadProjectFile(fileref, downloadFilename).then(
      () => {
        setDownloadingFile((prevDown) => ({
          ...prevDown,
          [fileid]: false,
        }));
      },
      (error) => {
        console.error('Fetching file url', error);
        setDownloadingFile((prevDown) => ({
          ...prevDown,
          [fileid]: false,
        }));
      }
    );
  };

  const file_questions = firebaseDataContext.definitions[aapId].tabs.filter((t) => t.tab_id === 'tab_annexes')[0].sections[0].questions.filter((q) => q.type === 'file');

  const averageScoreMap = evaluationQuestions.reduce(
    (prev, q) => {
      if (!isGlobal && q.only_theme_admin) return prev;
      if (q.conditional) {
        const field = q.conditional.field || '';
        const value = q.conditional.value || [];
        const projectEntry = q.conditional.status_field ? projectData.status : projectData.data;
        if (!value.includes(projectEntry[field])) {
          return prev;
        }
      }

      if (q.name in currentEvaluation && q.eval_type === 'cote') {
        if (currentEvaluation[q.name] > 0) {
          prev.n += 1;
          prev.s += currentEvaluation[q.name];
        }
      }
      return prev;
    },
    { n: 0, s: 0 }
  );

  const averageScore = averageScoreMap.n > 0 ? Math.round((100 * averageScoreMap.s) / averageScoreMap.n) / 100 : null;

  const isJustificationFilled = () => {
    return evaluationQuestions.map((q) => {
      if (!isGlobal && q.only_theme_admin) return true;
      if (q.conditional) {
        const field = q.conditional.field || '';
        const value = q.conditional.value || [];
        const projectEntry = q.conditional.status_field ? projectData.status : projectData.data;
        if (value.includes(projectEntry[field])) {
          return evaluationState[q.name + '_justification'] ? true : false;
        }
        return true;
      } else {
        return evaluationState[q.name + '_justification'] ? true : false;
      }
    });
  };
  // Global review
  let reviewersEvaluations = [];
  let isClosedEvaluation = false;
  if (isGlobal) {
    const curTheme = (firebaseDataContext.themes || []).filter((t) => t.name === themeName)[0];

    if (curTheme && projectId in curTheme.reviewers) {
      curTheme.reviewers[projectId].forEach((rev) => {
        const revEval = (reviewersListContext.reviewersEvaluations[rev] || {})[projectId] || {};
        revEval['revUid'] = rev;
        revEval['revEmail'] = (reviewersListContext.reviewersList.filter((r) => r.uid === rev)[0] || {}).email;
        // reviewersEvaluations.push(revEval[firebaseDataContext.evaluation_flag] ? revEval : {}); // only show submitted evals
        reviewersEvaluations.push(revEval); // show evals
      });
    }

    if (evaluationState.status && evaluationState.status[evaluationFlag]) {
      isClosedEvaluation = true;
    }
  }
  const adminstrativeReviewParameters = (firebaseDataContext.evaluationDefinitions[evaluationFlag] || {}).adminstrativeReviewParameters || {};

  const mapResultColor = (resultValue) => {
    return ((adminstrativeReviewParameters.results || []).filter((ar) => ar.value === resultValue)[0] || {}).color || '';
    // if (resultValue === 'rejected') return 'error';
    // if (resultValue === 'accepted') return 'warning';
    // if (resultValue === 1) return 'secondary';
    // return '';
  };

  const closingEvaluation = (sub) => {
    setSubmittingEvaluation(true);

    firebaseContext.app
      .closeEvaluationGlobal(projectId, {
        ...sub,
        evaluationFlag: evaluationFlag,
      })
      .then(
        (closingResult) => {
          // setSubmittingEvaluation(false);
          // history.replace(routes.ADMIN);
          navigate(`${routes.ADMIN}${routes.GLOBAL_EVALUATION}`, { replace: true });
        },
        (closingError) => {
          console.error('closing error', closingError);
          setSubmittingEvaluation(false);
        }
      );
  };

  return (
    <Container component="div" maxWidth={false} style={{ paddingTop: 20, paddingBottom: 50 }}>
      <Box display="flex" alignItems="flex-start">
        <Box flexGrow={1}>
          <Typography className={classes.pageTitle} variant="h1" component="div">
            &#8220; {projectData.data.acronyme || '???'} &#8221;
          </Typography>
        </Box>

        <Box>
          <Button variant="contained" color="primary" startIcon={<ArrowBackIcon />} onClick={goBackToList}>
            retour
          </Button>
        </Box>
      </Box>
      <Box className={classes.projectBy}>by {projectData.data.identity}</Box>
      <Box className={classes.projectCategoryAndTheme}>
        <u>Catégories</u> : {firebaseDataContext['definitionsRead'] && firebaseDataContext.definitions[aapId].name_fr} - <u>Thématique</u> : {themeName}
      </Box>

      {isClosedEvaluation && (
        <Paper elevation={2} sx={{ p: 2, borderWidth: 2, borderStyle: 'solid', mb: 2 }} className={clsx(colors.borderOrange)}>
          <Box component="span" sx={{ verticalAlign: 'middle' }}>
            <strong className="orange"> L'évaluation est cloturée</strong>
          </Box>
        </Paper>
      )}
      {isGlobal && projectData.status.lang === 'nl' && (
        <Paper elevation={2} sx={{ p: 2, borderWidth: 2, borderStyle: 'solid' }} className={clsx(colors.borderRed)}>
          <Box component="span" sx={{ verticalAlign: 'middle' }}>
            <GppMaybeIcon color="error" />
          </Box>
          <Box component="span" sx={{ verticalAlign: 'middle' }}>
            <strong className="red"> Attention: le projet a été soumis en Néerlandais!</strong>
          </Box>
        </Paper>
      )}
      <Accordion expanded={expanded === 'panel1'} onChange={handleAccordionChange('panel1')} className={classes.projectFilesAccordion}>
        <AccordionSummary
          className={classes.projectFilesAccordionSummary}
          expandIcon={<ExpandMoreIcon />}
          // expandIconWrapper={{ style: { color: 'white' } }}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>Télécharger les fichiers du projet</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.projectFilesAccordionDetails}>
          <Box component="div" className={classes.projectFilesAccordionDetailsBox}>
            <Button disabled={downloading} variant="contained" color="primary" onClick={downloadProjectPDF}>
              {!downloading ? 'Télécharger le formulaire de candidature' : <CircularProgress disableShrink thickness={3} size={20} />}
            </Button>
          </Box>

          {file_questions.map((q) => {
            const qFileData = projectData.data[`${q.id}`];
            // const qFileData = null;
            return (
              <Box key={q.id} component="div">
                {qFileData && (
                  <div className={classes.projectFilesAccordionDetailsBox}>
                    <Typography>{q.label_fr.replace(/<.+>/g, '')}:</Typography>
                    <Button
                      disabled={downloading}
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        downloadFile(qFileData.fileref, q.id);
                      }}
                    >
                      {!downloadingFile[q.id] ? qFileData.filename : <CircularProgress disableShrink thickness={3} size={20} />}
                    </Button>
                  </div>
                )}
              </Box>
            );
          })}
        </AccordionDetails>
      </Accordion>
      {averageScore !== null && (
        <Paper className={classes.scorePaper}>
          <Container component="div" maxWidth={false}>
            <Box style={{ textAlign: 'center' }}>
              <Typography className={classes.scoreTitle}>Moyenne du projet</Typography>
              <div className={clsx(classes.score, { [classes.green]: averageScore <= 20, [classes.blue]: averageScore <= 15, [classes.orange]: averageScore <= 10, [classes.red]: averageScore <= 5 })}>
                {' '}
                {averageScore}/20
              </div>
            </Box>
          </Container>
        </Paper>
      )}

      <Box sx={{ display: 'flex' }}>
        <Box sx={{ flex: 1, maxWidth: '100%' }}>
          <form
            ref={evaluationForm}
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            {evaluationQuestions.map((question) => {
              if (!isGlobal && question.only_theme_admin) return <div key={'skipped_' + question.name}></div>;
              if (question.conditional) {
                const field = question.conditional.field || '';
                const value = question.conditional.value || [];
                const projectEntry = question.conditional.status_field ? projectData.status : projectData.data;
                if (!value.includes(projectEntry[field])) {
                  return <div key={'skipped_' + question.name}></div>;
                }
              }

              return (
                <SimpleQuestion
                  key={question.name}
                  submittingEvaluation={submittingEvaluation}
                  isClosedEvaluation={isClosedEvaluation}
                  // currentEvaluation={evaluationState}
                  criteres={question.criteres || null}
                  defaultAnswer={question.defaultAnswer || ''}
                  currentValue={evaluationState[question.name]}
                  // currentMessage={evaluationState[question.name + '_message']}
                  currentJustification={evaluationState[question.name + '_justification']}
                  currentRecommandation={evaluationState[question.name + '_recommandation']}
                  handleChange={handleEvaluationChange}
                  name={question.name}
                  title={question.title.fr}
                  eval_type={question.eval_type}
                  text={question.text}
                  answerLimit={question.answerLimit}
                  isGlobal={isGlobal}
                  reviewersEvaluations={reviewersEvaluations}
                  onlyThemeAdmin={question.only_theme_admin}
                  evaluationFlag={evaluationFlag}
                />
              );
            })}
          </form>
        </Box>
      </Box>

      {isGlobal &&
        firebaseDataContext.administrativeReviewsRead &&
        projectId in firebaseDataContext.administrativeReviews &&
        firebaseDataContext.administrativeReviews[projectId].status === 'reviewed' &&
        firebaseDataContext.administrativeReviews[projectId].flag === evaluationFlag && (
          <Paper elevation={2} sx={{ p: 2, borderStyle: 'solid', borderWidth: 1 }} className={clsx(colors.borderBlue)}>
            <Typography>Analyse administrative</Typography>
            {firebaseDataContext.administrativeReviews[projectId].result !== null && (
              <Box sx={{ mt: 2 }}>
                <Typography>
                  Résultat: &nbsp;&nbsp;

                  <TrafficIcon color={mapResultColor(firebaseDataContext.administrativeReviews[projectId].result)} sx={{ fontSize: 40, verticalAlign: 'middle' }} />
                </Typography>
              </Box>
            )}
            {firebaseDataContext.administrativeReviews[projectId].message !== null && (
              <Box sx={{ mt: 2 }}>
                <Typography>Message:</Typography>

                <TextField name="message" value={firebaseDataContext.administrativeReviews[projectId].message} variant="outlined" disabled multiline={true} fullWidth={true} />
              </Box>
            )}
          </Paper>
        )}

      {/* globalSubmission */}
      {isGlobal &&
        !isClosedEvaluation &&
        (isJustificationFilled().filter((v) => v === false).length > 0 ? (
          <Paper elevation={2} sx={{ p: 2, mt: '30px', borderWidth: 2, borderStyle: 'solid' }} className={clsx(colors.borderOrange)}>
            <strong className="orange">
              <p>Vous devez compléter toutes les justifications pour pouvoir terminer l'évaluation!</p>
              <p>Justifcations manquantes:</p>
              <ul>
                {isJustificationFilled().map((v, ix) => {
                  if (v !== false) return <span key={ix}></span>;
                  return <li key={ix}>{evaluationQuestions[ix].short_title.fr}</li>;
                })}
              </ul>
            </strong>
          </Paper>
        ) : (
          <Paper elevation={2} sx={{ p: 2, mt: '30px', borderWidth: 2, borderStyle: 'solid' }} className={clsx(colors.borderBlue)}>
            <SubmissionContent
              evaluationQuestions={evaluationQuestions}
              evaluationState={evaluationState}
              submittingEvaluation={submittingEvaluation}
              lang={projectData.status.lang}
              submitClosing={closingEvaluation}
              evaluationFlag={evaluationFlag}
              administrativeReview={firebaseDataContext.administrativeReviews[projectId]}
              projectData={projectData}
              evaluationParameters={evaluationParameters}
            />
          </Paper>
        ))}

      {isGlobal && isClosedEvaluation && (
        <Paper elevation={2} sx={{ p: 2, mt: '30px' }}>
          <Typography sx={{ mb: 2 }}>
            <strong>Messages envoyés:</strong>
          </Typography>

          {(evaluationState.messages || []).map((m) => {
            return (
              <Accordion key={m.date.toDate().toISOString()}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                  <Typography>{m.date.toDate().toLocaleString()}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {/* <Typography dangerouslySetInnerHTML={{__html:m.message.replace('\n', '<br/>')}}></Typography> */}
                  <TextField disabled variant="outlined" multiline={true} rows={6} fullWidth={true} value={m.message} />
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Paper>
      )}

      {!currentEvaluation[evaluationFlag] && !isGlobal && (
        <Paper>
          <Container component="div" maxWidth={false} className={classes.closePaper}>
            <Box>
              <Typography variant="h6" style={{ marginBottom: 10 }}>
                Cloturer l'évaluation
              </Typography>
            </Box>
            <Typography component="p" style={{ display: 'block', fontSize: '.8rem' }}>
              La cloture d'une évaluation est purement informative pour les administrateurs
            </Typography>

            <div className={classes.closeContainer}>
              <Button variant="contained" color="secondary" disabled={submittingEvaluation} onClick={setEvaluationClose}>
                Indiquer l'évaluation comme cloturée
              </Button>
            </div>
          </Container>
        </Paper>
      )}

      {evaluationStateApplied && (
        <div className={classes.saveContainer + ' ' + (stateEqualCurrentEvaluation ? '' : classes.showSave)}>
          <Button
            variant="contained"
            disabled={submittingEvaluation}
            color="primary"
            onClick={() => {
              submitEvaluation();
            }}
          >
            {!submittingEvaluation ? 'Sauvegarder' : <CircularProgress thickness={4} size={24} />}
          </Button>
          <Typography component="p" style={{ marginTop: 10, display: 'block', fontSize: '.8rem' }}>
            Vous devez sauvegarder votre analyse pour l'enregistrer.
          </Typography>
        </div>
      )}
    </Container>
  );
};

// const RenderSimpleQuestion = ({ data, index, style }) => {
//   const { evaluationQuestions, isGlobal, projectData, evaluationState, reviewersEvaluations, evaluationFlag, submittingEvaluation, isClosedEvaluation, handleEvaluationChange } = data;

//   const question = evaluationQuestions[index];

//   if (!isGlobal && question.only_theme_admin) {
//     console.log(index, 'skipped admin');
//     return <div key={'skipped_' + question.name}></div>;
//   }
//   if (question.conditional) {
//     const field = question.conditional.field || '';
//     const value = question.conditional.value || [];
//     const projectEntry = question.conditional.status_field ? projectData.status : projectData.data;
//     if (!value.includes(projectEntry[field])) {
//       console.log(index, 'skipped conditional');
//       return <div key={'skipped_' + question.name}></div>;
//     }
//   }

//   return (
//     <>
//       <SimpleQuestion
//         key={question.name}
//         submittingEvaluation={submittingEvaluation}
//         isClosedEvaluation={isClosedEvaluation}
//         // currentEvaluation={evaluationState}
//         criteres={question.criteres || null}
//         currentValue={evaluationState[question.name]}
//         // currentMessage={evaluationState[question.name + '_message']}
//         currentJustification={evaluationState[question.name + '_justification']}
//         currentRecommandation={evaluationState[question.name + '_recommandation']}
//         handleChange={handleEvaluationChange}
//         name={question.name}
//         title={question.title.fr}
//         eval_type={question.eval_type}
//         text={question.text}
//         isGlobal={isGlobal}
//         reviewersEvaluations={reviewersEvaluations}
//         onlyThemeAdmin={question.only_theme_admin}
//         evaluationFlag={evaluationFlag}
//       />
//     </>
//   );
// };

const simpleQuestionStyles = makeStyles((theme) => ({
  checkContent: {
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: 30,
    border: '1px solid #666',
    borderColor: theme.palette.primary.main,
    borderRadius: 5,
  },
  sliderContainer: {
    width: '70%',
    maxWidth: '700px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 0,
  },
  sliderScore: {
    color: '#333',
    fontSize: '1.2rem',
    fontWeight: '600',
    textAlign: 'center',
  },
  sliderGreen: {
    color: `${theme.palette.secondary.main}!important`,
  },
  sliderBlue: {
    color: `${theme.palette.primary.main}!important`,
  },
  sliderOrange: {
    color: `${theme.palette.warning.main}!important`,
  },
  sliderRed: {
    color: `${theme.palette.error.main}!important`,
  },
  sliderPurple: {
    color: `${theme.palette.info.main}!important`,
  },
  formControl: {
    margin: theme.spacing(1),
    marginLeft: 'auto',
    marginRight: 'auto',
    minWidth: 150,
    verticalAlign: 'middle',
  },
  messageLength: {
    textAlign: 'right',
    fontSize: '.8rem',
    color: '#666',
    marginTop: 5,
  },
  tabGreen: {
    color: '#42aa06',
    '&.Mui-selected': {
      backgroundColor: '#42aa06',
      color: '#333',
    },
  },
  tabBlue: {
    color: '#005aad',
    '&.Mui-selected': {
      backgroundColor: '#005aad',
      color: '#333',
    },
  },
  tabOrange: {
    color: '#fd6200',
    '&.Mui-selected': {
      backgroundColor: '#fd6200',
      color: '#333',
    },
  },
  tabRed: {
    color: '#f44436',
    '&.Mui-selected': {
      backgroundColor: '#f44436',
      color: '#333',
    },
  },
  tabPurple: {
    color: '#c70083',
    '&.Mui-selected': {
      backgroundColor: '#c70083',
      color: '#333',
    },
  },
  box: {
    border: 2,
    borderRadius: 5,
    borderStyle: 'solid',
    borderColor: '#ccc',
  },
  boxGreen: {
    borderColor: '#42aa06',
  },
  boxBlue: {
    borderColor: '#005aad',
  },
  boxOrange: {
    borderColor: '#fd6200',
  },
  boxRed: {
    borderColor: '#f44436',
  },
  boxPurple: {
    borderColor: '#c70083',
  },
  scoreContainer: {
    padding: 5,
    // background: 'white',
    borderRadius: 3,
    fontSize: '.8rem',
    fontWeight: 'bold',
    marginLeft: 20,
    marginRight: 20,
  },
  waitingScore: {
    border: '1px solid #666',
  },
}));

const TabPanel = (props) => {
  const { children, value, index, close, boxClass, tabID, text, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`${tabID}-tabpanel-${index}`} aria-labelledby={`critere-tab-${index}`} {...other}>
      {value === index && (
        <Box sx={{ p: 1, border: 1 }} className={boxClass}>
          <IconButton aria-label="delete" onClick={close}>
            <CloseIcon />
          </IconButton>
          {text && <Box dangerouslySetInnerHTML={{ __html: text }}></Box>}
          {!text && children}
        </Box>
      )}
    </div>
  );
};

const SimpleQuestion = (props) => {
  const classes = simpleQuestionStyles();
  const colors = colorStyles();
  const parentRecom = useRef();
  const parentJustif = useRef();

  const [justification, setJustification] = useState(props.defaultAnswer || '');
  const [recommandation, setRecommandation] = useState('');

  const [sliderValue, setSliderValue] = useState(null);
  // const [message, setMessage] = useState('');

  const maximumMessageLength = props.answerLimit ?? 3000;
  // const messageLength = (props.currentMessage || '').length;

  const changeSliderValue = (event, newValue) => {
    setSliderValue(newValue);
  };
  // const propagateSliderValue = () => {
  //   props.handleChange({ target: { name: props.name, value: sliderValue } });
  // };

  // const handleChangeMessage = ({target}) =>{
  //   setMessage(target.value)
  // }

  const previousPropValue = props.currentValue;
  // const previousMessageValue = props.currentEvaluation[props.name + 'Message'];

  useEffect(() => {
    setSliderValue(previousPropValue ?? null);
  }, [previousPropValue]);

  // edit state from props
  useEffect(() => {
    setJustification(props.currentJustification);
  }, [props.currentJustification]);
  useEffect(() => {
    setRecommandation(props.currentRecommandation);
  }, [props.currentRecommandation]);

  // useEffect(() => {
  //   setMessage(previousMessageValue || "");
  // }, [previousMessageValue]);

  const [tabValue, setTabValue] = useState(false);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const closeTab = () => {
    setTabValue(false);
  };

  const [justificationTabValue, setJustificationTabValue] = useState(false);
  const handleRevJustifTabChange = (event, newValue) => {
    setJustificationTabValue(newValue);
  };
  const closeJustificationTab = () => {
    setJustificationTabValue(false);
  };

  const [recommandationTabValue, setRecommandationTabValue] = useState(false);
  const handleRevRecommandationTabChange = (event, newValue) => {
    setRecommandationTabValue(newValue);
  };
  const closeRecommandationTab = () => {
    setRecommandationTabValue(false);
  };

  let meanEvalScore;
  if (props.isGlobal) {
    const agg = props.reviewersEvaluations
      .filter((revEval) => props.name in revEval)
      .reduce(
        (p, c) => {
          p.nb += 1;
          p.t += c[props.name];
          return p;
        },
        { nb: 0, t: 0 }
      );
    if (agg.nb === 0) {
      meanEvalScore = null;
    } else {
      meanEvalScore = agg.t / agg.nb;
    }
  }

  return (
    <Paper>
      <Container component="div" maxWidth={false} className={classes.checkContent}>
        <Box>
          <Typography variant="h6" style={{ marginBottom: 10 }} dangerouslySetInnerHTML={{ __html: props.title }}></Typography>
          {props.text && <div style={{ margin: '5px 0', fontSize: '.8rem' }} dangerouslySetInnerHTML={{ __html: props.text }}></div>}
        </Box>

        {props.criteres && (
          <Paper elevation={2} sx={{ p: 1 }}>
            <Box sx={{ width: '100%' }}>
              <Box>
                <Typography>Critères d'évaluation:</Typography>
              </Box>
              <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
                <Tabs value={tabValue} onChange={handleTabChange} aria-label="Tabs critères" variant="scrollable" scrollButtons="auto">
                  {props.criteres.map((c, cidx) => {
                    return (
                      <Tab
                        label={c.label}
                        key={`critere-tab-${cidx}`}
                        id={`critere-tab-${cidx}`}
                        aria-controls={`critere-tabpanel-${cidx}`}
                        className={clsx(c.color ? classes[`tab${c.color}`] : '')}
                      />
                    );
                  })}
                </Tabs>
              </Box>
              {props.criteres.map((c, cidx) => {
                return (
                  <TabPanel
                    key={`panel_${cidx}`}
                    tabID="critere"
                    value={tabValue}
                    index={cidx}
                    close={closeTab}
                    boxClass={clsx(c.color ? classes[`box${c.color}`] : '', classes.box)}
                    text={c.text || null}
                  ></TabPanel>
                );
              })}
            </Box>
          </Paper>
        )}

        {props.isGlobal && !props.onlyThemeAdmin && (
          <Paper elevation={2} sx={{ p: 1, mt: 2 }}>
            <Box sx={{ width: '100%' }}>
              <Box>
                <Typography>Evaluations des experts:</Typography>
              </Box>
              <Box sx={{ p: 1, textAlign: 'center' }}>
                {props.reviewersEvaluations.map((revEval, revIdx) => {
                  const revScore = revEval[props.name] ?? null;

                  const evalClosed = revEval[props.evaluationFlag] || false;

                  return (
                    <Box key={revIdx} component="span" sx={{ verticalAlign: 'middle', ml: '5px', mr: '5px' }}>
                      {revScore !== null && (
                        <Box
                          component="span"
                          className={clsx(
                            {
                              [colors.bckgGreen]: (typeof revScore !== 'boolean' && revScore > 15 && revScore <= 20 && evalClosed) || (typeof revScore === 'boolean' && revScore && evalClosed),
                              [colors.bckgBlue]: typeof revScore !== 'boolean' && revScore > 10 && revScore <= 15 && evalClosed,
                              [colors.bckgOrange]: typeof revScore !== 'boolean' && revScore > 5 && revScore <= 10 && evalClosed,
                              [colors.bckgRed]: (typeof revScore !== 'boolean' && revScore >= 0 && revScore <= 5 && evalClosed) || (typeof revScore === 'boolean' && !revScore && evalClosed),

                              [colors.green]: (typeof revScore !== 'boolean' && revScore > 15 && revScore <= 20 && !evalClosed) || (typeof revScore === 'boolean' && revScore && !evalClosed),
                              [colors.blue]: typeof revScore !== 'boolean' && revScore > 10 && revScore <= 15 && !evalClosed,
                              [colors.orange]: typeof revScore !== 'boolean' && revScore > 5 && revScore <= 10 && !evalClosed,
                              [colors.red]: (typeof revScore !== 'boolean' && revScore >= 0 && revScore <= 5 && !evalClosed) || (typeof revScore === 'boolean' && !revScore && !evalClosed),

                              // [colors.bckgGreen]: ,
                              // [colors.bckgRed]: ,
                              // [colors.green]: typeof revScore === 'boolean' && revScore && revScore <= 20 && !revEval[props.evaluationFlag],
                              // [colors.red]: typeof revScore === 'boolean' && !revScore && revScore < 5 && !revEval[props.evaluationFlag],

                              [classes.waitingScore]: !evalClosed,
                              [colors.white]: evalClosed,
                            },
                            classes.scoreContainer
                          )}
                        >
                          {typeof revScore === 'boolean' ? (revScore ? 'Oui' : 'Non') : revScore}
                        </Box>
                      )}
                      {revScore === null && <NoAccountsIcon color="warning" />}
                    </Box>
                  );
                })}

                {meanEvalScore !== null && props.eval_type !== 'boolean' && (
                  <>
                    &nbsp;<strong>Moyenne:</strong>
                    <Box
                      component="span"
                      className={clsx(
                        {
                          [colors.bckgGreen]: meanEvalScore > 15 && meanEvalScore <= 20,
                          [colors.bckgBlue]: meanEvalScore > 10 && meanEvalScore <= 15,
                          [colors.bckgOrange]: meanEvalScore > 5 && meanEvalScore <= 10,
                          [colors.bckgRed]: meanEvalScore >= 0 && meanEvalScore <= 5,
                        },
                        classes.scoreContainer,
                        colors.white
                      )}
                    >
                      {meanEvalScore}
                    </Box>
                  </>
                )}
              </Box>

              {props.reviewersEvaluations.length === 0 && <Typography>Aucun reviewer n'a été attribué</Typography>}
              {props.reviewersEvaluations.length > 0 && (
                <>
                  <Box>
                    <Typography>Justifications:</Typography>
                  </Box>

                  <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
                    <Tabs value={justificationTabValue} onChange={handleRevJustifTabChange} aria-label="Tabs justifications" variant="scrollable" scrollButtons="auto">
                      {props.reviewersEvaluations.map((c, cidx) => {
                        const r = get_rank(c.revEmail);
                        let revText;
                        if (r === 4) {
                          revText = `Expert ${cidx + 1}`;
                        } else {
                          revText = get_rev_short(r === 100 ? 6 : r);
                        }

                        return (
                          <Tab
                            label={revText}
                            key={`justification-tab-${cidx}`}
                            id={`justification-tab-${cidx}`}
                            aria-controls={`justification-tabpanel-${cidx}`}
                          // className={clsx(c.color ? classes[`tab${c.color}`] : '')}
                          />
                        );
                      })}
                    </Tabs>
                  </Box>

                  {props.reviewersEvaluations.map((c, cidx) => {
                    return (
                      <TabPanel
                        tabID="justification"
                        key={`justificaton_panel_${cidx}`}
                        value={justificationTabValue}
                        index={cidx}
                        close={closeJustificationTab}
                        boxClass={clsx(c.color ? classes[`box${c.color}`] : '', classes.box)}
                        text={(c[`${props.name}_justification`] || '<strong class="orange">Non justifié<strong>').replaceAll('\n', '<br/>')}
                      ></TabPanel>
                    );
                  })}

                  <Box>
                    <Typography>Recommandations:</Typography>
                  </Box>
                  <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
                    <Tabs value={recommandationTabValue} onChange={handleRevRecommandationTabChange} aria-label="Tabs recommandations" variant="scrollable" scrollButtons="auto">
                      {props.reviewersEvaluations.map((c, cidx) => {
                        const r = get_rank(c.revEmail);
                        let revText;
                        if (r === 4) {
                          revText = `Expert ${cidx + 1}`;
                        } else {
                          revText = get_rev_short(r === 100 ? 6 : r);
                        }
                        return (
                          <Tab
                            label={revText}
                            key={`recommandation-tab-${cidx}`}
                            id={`recommandation-tab-${cidx}`}
                            aria-controls={`recommandation-tabpanel-${cidx}`}
                          // className={clsx(c.color ? classes[`tab${c.color}`] : '')}
                          />
                        );
                      })}
                    </Tabs>
                  </Box>
                  {props.reviewersEvaluations.map((c, cidx) => {
                    return (
                      <TabPanel
                        tabID="recommandation"
                        key={`recommandation_panel_${cidx}`}
                        value={recommandationTabValue}
                        index={cidx}
                        close={closeRecommandationTab}
                        // boxClass={clsx(c.color ? classes[`box${c.color}`] : '', classes.box)}
                        text={(c[`${props.name}_recommandation`] || '<div class="blue">Pas de recommandation<div>').replaceAll('\n', '<br/>')}
                      ></TabPanel>
                    );
                  })}
                </>
              )}
            </Box>
          </Paper>
        )}

        <Box>
          <Typography sx={{ mt: 3 }}>Evaluation:</Typography>
          <Grid container className={classes.sliderContainer} spacing={3} alignItems="center" sx={{ position: 'relative' }}>
            {props.eval_type === 'cote' && (
              <>
                <Grid item xs={9} >
                  <PrettoSlider
                    disabled={props.submittingEvaluation || props.isClosedEvaluation}
                    className={clsx({
                      [classes.sliderRed]: sliderValue !== null && sliderValue >= 0 && sliderValue <= 5,
                      [classes.sliderOrange]: sliderValue !== null && sliderValue > 5 && sliderValue <= 10,
                      [classes.sliderBlue]: sliderValue !== null && sliderValue > 10 && sliderValue <= 15,
                      [classes.sliderGreen]: sliderValue !== null && sliderValue > 15 && sliderValue <= 20,
                      [classes.sliderPurple]: sliderValue === null,
                    })}
                    valueLabelDisplay="auto"
                    aria-label="pretto slider"
                    min={0}
                    max={20}
                    step={1}
                    value={sliderValue}
                    onChange={changeSliderValue}
                  // onChangeCommitted={propagateSliderValue}
                  />
                </Grid>
                <Grid item xs={3} className={classes.sliderScore} >
                  {/* {props.currentValue} / 20 */}
                  {sliderValue} / 20
                </Grid>
                {sliderValue !== null && <input readOnly style={{ position: 'absolute', opacity: 0, visibility: "hidden" }} type="number" name={'[CN]' + props.name} value={parseInt(sliderValue)}></input>}
              </>
            )}

            {props.eval_type === 'boolean' && (
              <FormControl variant="outlined" className={classes.formControl}>
                <Select
                  disabled={props.submittingEvaluation || props.isClosedEvaluation}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  // value={typeof props.currentValue === 'boolean' ? props.currentValue : (props.currentValue ? props.currentValue === 'true' : '')}
                  value={typeof props.currentValue === 'boolean' ? props.currentValue : ''}
                  name={props.name}
                  onChange={props.handleChange}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value={true}>Oui</MenuItem>
                  <MenuItem value={false}>Non</MenuItem>
                </Select>
              </FormControl>
            )}
          </Grid>
        </Box>

        <Box className={classes.commentBox} ref={parentJustif}>
          <p> Justification {props.eval_type !== 'boolean' && 'de la note par rapport à la grille de sélection'} </p>
          <TextField
            disabled={props.submittingEvaluation || props.isClosedEvaluation}
            name={props.name + '_justification'}
            // onChange={(e) => props.handleChange(e, parentJustif)}
            // value={props.currentJustification}
            onChange={(e) => setJustification(e.target.value)}
            value={justification}
            // onBlur={(e) => props.handleChange(e, parentJustif)}
            placeholder="Justifiez votre note"
            variant="outlined"
            multiline={true}
            rows={4}
            fullWidth={true}
            inputProps={{ maxLength: maximumMessageLength }}
          />
          <div className={classes.messageLength}>
            {(justification || '').length}/{maximumMessageLength}
          </div>
        </Box>

        <Box className={classes.commentBox} ref={parentRecom}>
          <p> Recommandations à destination du candidat (valable autant pour les projets retenus que non retenus)</p>
          <TextField
            disabled={props.submittingEvaluation || props.isClosedEvaluation}
            name={props.name + '_recommandation'}
            // onChange={(e) => props.handleChange(e, parentRecom)}
            // value={props.currentRecommandation}
            onChange={(e) => setRecommandation(e.target.value)}
            value={recommandation}
            // onBlur={(e) => props.handleChange(e, parentRecom)}
            placeholder="Insérer un commentaire"
            variant="outlined"
            multiline={true}
            rows={4}
            fullWidth={true}
            inputProps={{ maxLength: maximumMessageLength }}
          />
          <div className={classes.messageLength}>
            {(recommandation || '').length}/{maximumMessageLength}
          </div>
        </Box>
      </Container>
    </Paper>
  );
};

const PrettoSlider = withStyles({
  root: {
    height: 8,
    transition: 'color linear 250ms',
  },
  // thumb: {
  //   height: 24,
  //   width: 24,
  //   backgroundColor: '#fff',
  //   border: '2px solid currentColor',
  //   marginTop: -8,
  //   marginLeft: -12,
  //   '&:focus, &:hover, &$active': {
  //     boxShadow: 'inherit',
  //   },
  // },
  // active: {},
  // valueLabel: {
  //   left: 'calc(-50% + 4px)',
  // },
  // track: {
  //   height: 8,
  //   borderRadius: 4,
  // },
  // rail: {
  //   height: 8,
  //   borderRadius: 4,
  // },
})(Slider);

const SubmissionContentStyles = makeStyles((theme) => ({
  checkContent: {
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: 30,

    '&.notEditable ': {
      borderColor: '#666!important',
    },

    '&.notSubmitted': {
      borderWidth: 2,
      borderColor: theme.palette.error.main,
    },
  },
  submitContainer: {
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
  },
  inlineElement: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: 15,
  },
  closeContainer: {
    textAlign: 'center',
    height: 'auto',
    padding: 30,
  },
  closeButton: {
    color: 'white',
    '&.button-accepted': {
      backgroundColor: theme.palette.secondary.main,
    },
    '&.button-rejected': {
      backgroundColor: theme.palette.error.main,
    },
    '&.button-NYD': {
      backgroundColor: theme.palette.info.main,
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    verticalAlign: 'middle',
  },
}));

const SubmissionContent = (props) => {
  // const classes = useStyles();
  const submissionStyle = SubmissionContentStyles();

  // const theme = useTheme();
  const { evaluationParameters } = props;

  const [submission, setSubmission] = useState({
    result: '',
    message: '',
    subject: '',
  });

  const closeReview = () => {
    props.submitClosing({
      ...submission,
      // status: 'reviewed',
      // status: submission.result === 'NYD' ? 'pending' : 'reviewed',
    });
  };

  const subjects = {
    fr: {
      accepted: `VOTRE CANDIDATURE AU 1ER TOUR DE L’APPEL A PROJET BE CIRCULAR ${APP_YEAR}`,
      rejected: `VOTRE CANDIDATURE AU 1ER TOUR DE L’APPEL A PROJET BE CIRCULAR ${APP_YEAR}`,
      // NYD: 'Candidature BeCircular 2021 : demande d’informations complémentaires',
    },
    nl: {
      accepted: `UW KANDITATUUR VOOR DE EERSTE RONDE VAN DE BECIRCULAR ${APP_YEAR}`,
      rejected: `UW KANDITATUUR VOOR DE EERSTE RONDE VAN DE BECIRCULAR ${APP_YEAR}`,
      // NYD: 'kandidaatstelling Be Circular 2021: verzoek om bijkomende informatie',
    },
  };
  const defaultMessage = {
    fr: {
      accepted:
        `Madame, Monsieur,\n\nNous vous remercions pour l'introduction de votre dossier de candidature dans le cadre du 1er tour de l'appel à projets « Be Circular – Be Brussels ${APP_YEAR}. L'économie circulaire s'installe encore un peu plus en région bruxelloise et les entreprises sont loin d'être à court d'idées, en témoignent le nombre des dossiers reçus pour le 1er tour de cette nouvelle édition.\n\nL'ensemble des dossiers ont été analysés par un jury composé des 3 administrations qui coordonnent l'appel à projets. Le jury a ainsi établi un classement et Be Circular étant un concours, seuls les meilleurs dossiers par ordre de classement ont été présélectionnés à l'issue de ce 1er tour de candidature. \n\nNous nous réjouissons de votre démarche proactive dans le cadre d'une transition vers une économie circulaire à Bruxelles et avons le plaisir de vous informer que votre projet a été sélectionné pour le 2ème tour de l'appel à projet « Be Circular ${APP_YEAR} ». Vous trouverez ci-dessous une synthèse de l'analyse de votre dossier par le jury Be Circular.\n\nPour ce 2ème tour vous devrez soumettre un dossier complet (comprenant un plan financier) au plus tard pour le 30 juin ${APP_YEAR} à midi.\n\nSéance d'information sur le 2ème tour – 18 avril\n \nParticipez à la session d'information organisée le 18 avril de 17h à 19h45 chez hub.brussels (chaussée de charleroi 110). Vous obtiendrez plus d'informations sur les modalités de candidature du 2ème tour et sur l'accompagnement gratuit offert pour vous aider à constituer votre dossier. L'événement se prolongera avec un moment de networking autour d'un buffet, pour d'échanger entre vous ou avec les différents.es intervenants.es.\nJe m'inscris avant le 13 avril (https://www.flexmail.eu/f-329f7f57406a8cfb) ! \n \nAccompagnements\n \nPlusieurs dispositifs sont disponibles pour vous aider dans la préparation de votre dossier :  \n \n1. Accompagnement gratuit par des coaches experts pour vous aider à renforcer vos projets sur les volets : \n    Impact environnemental\n    Faisabilité technico-économique \n    Viabilité financière\n \nCes coaches ont des expertises en matière de durabilité, circularité, entrepreneuriat, finance,... et sont familiers avec l'appel à projets Be Circular.\nInscrivez-vous sans tarder (https://forms.gle/unR6UjJ1BJNu1QaVA) !\n \n2. La FAQ - questions fréquemment posées et réponses de l'appel à projets : www.circulareconomy.brussels/a-propos/faq/\n\n3. Le helpdesk en ligne sur la plateforme de candidature pour répondre à vos questions par écrit :  https://www.mycirculareconomy.brussels/support \n\nEn vous félicitant encore de votre engagement, nous vous prions de croire, Madame, Monsieur, à l'assurance de nos sentiments les meilleurs.`,
      rejected:
        `Madame, Monsieur,\n\nNous vous remercions pour l’introduction de votre dossier de candidature dans le cadre du 1er tour de l’appel à projets « Be Circular – Be Brussels ${APP_YEAR}. L’économie circulaire s’installe encore un peu plus en région bruxelloise et les entreprises sont loin d’être à court d’idées, en témoignent le nombre des dossiers reçus pour le 1er tour de cette nouvelle édition.\n\nL’ensemble des dossiers ont été analysés par un jury composé des 3 administrations qui coordonnent l’appel à projets. Le jury a ainsi établi un classement et BeCircular étant un concours, seuls les meilleurs dossiers par ordre de classement ont été présélectionnés.\n\nNous sommes au regret de devoir vous informer que votre projet ne fait pas partie des dossiers présélectionnés à l’issue du 1er tour de candidature. Vous trouverez ci-dessous une synthèse de l’analyse de votre dossier par le jury BeCircular.\n\nNous vous rappelons que l'appel à projet BeCircular n'est qu'un parmi les nombreux soutiens bruxellois de la transition économique. N'hésitez pas à parcourir l'ensemble de l'offre de soutien à l’économie circulaire en Région de Bruxelles Capitale : https://www.circulareconomy.brussels/offre-de-soutien-a-leconomie-circulaire/.\n\nNous nous réjouissons de votre intérêt et de votre démarche proactive dans le cadre d’une transition vers une économie circulaire, et nous espérons susciter à nouveau votre intérêt lors de la prochaine édition de l’appel à projets Be Circular début ${APP_YEAR + 1}.`,
      // NYD: 'Chère Madame, cher Monsieur,\n\nNous vous remercions de votre participation à l’appel à projets BeCircular – BeBrussels2021.\n\nIl ressort de la première analyse administrative de votre candidature que votre demande n’est pas complète / n’est pas encore en ordre. \n\nEn effet, il manque les documents suivants :\n\n1.\n\n2.\n\n\n\nPouvez-vous nous renvoyer les documents manquants / renvoyer les documents corrigés, via la plateforme de candidature, pour le mercredi 26 mai 2021 avant midi ?\n\nNous restons à votre disposition pour tout renseignement complémentaire.\n\nCordialement,\n\n\n\nL’équipe BeCircular – BeBrussels',
    },
    nl: {
      accepted:
        `Geachte heer of mevrouw,\n\nHartelijk dank voor het indienen van uw kandidatuur voor de eerste ronde van de "Be Circular - Be Brussels ${APP_YEAR}"-projectoproep. De circulaire economie begint wortel te schieten in het Brusselse gewest en aan ideeën ontbreekt het de bedrijven geenszins, zoals blijkt uit het aantal aanvragen dat voor de eerste ronde van deze nieuwe editie is ontvangen. In totaal werden 131 dossiers ingediend door ondernemingen, zelfstandigen of verenigingen uit de Brusselse economische wereld.\n\nAlle aanvragen zijn geanalyseerd door een jury bestaande uit de drie overheidsdiensten die de projectoproep coördineren. De jury stelde een ranglijst op en aangezien BeCircular een wedstrijd is, werden alleen de beste kandidaturen in volgorde van rangschikking voorgeselecteerd. \n\nWij zijn verheugd over uw proactieve aanpak van de overgang naar een circulaire economie in Brussel en zijn verheugd u te kunnen meedelen dat uw project is voorgeselecteerd voor de tweede ronde van de "Be Circular ${APP_YEAR}" projectoproep. Hieronder vindt u een samenvatting van de analyse die de BeCircular-jury van uw kandidatuur heeft gemaakt.\n\nVoor deze tweede ronde moet u uiterlijk op 30 juni ${APP_YEAR} om 12.00 uur een volledige kandidatuurdossier (inclusief een financieel plan) indienen.\n\nInformatiesessie over de 2de ronde – 18 april\n\nNeem deel aan de informatiesessie op 18 april, van 17 tot 19.45 uur bij hub.brussels (Charleroise Steenweg 110). Er wordt meer informatie gegeven over de voorwaarden waaraan een kandidatuur voor de 2de ronde moet voldoen en de omstandigheden waarin kandidaten gratis hulp kunnen krijgen om hun dossier samen te stellen. De avond wordt afgesloten met networking rondom een buffet, om onderlinge uitwisseling en contacten met de verschillende betrokkenen mogelijk te maken.\n\nIk schrijf me in vóór 13 april (https://www.flexmail.eu/f-329f7f57406a8cfb)!\n\nBegeleiding\n\nWie een dossier wil voorbereiden, kan via verschillende kanalen hulp krijgen:\n\n1. Gratis begeleiding door gespecialiseerde coaches die helpen om:\n    De milieu-impact van een project te verbeteren\n    De technisch economische haalbaarheid van een project na te gaan\n    De financiële leefbaarheid van een project af te toetsen\n\nDe coaches beschikken over expertise op het vlak van duurzaamheid, circulaire economie, ondernemerschap, financiën, ... én zijn vertrouwd met de Be Circular- projectoproep.\nSchrijf u meteen in (https://forms.gle/8mBX472X7kMRDdN67)!\n\n2. De 'FAQ' - veel gestelde vragen en antwoorden rond de projectoproep: https://www.circulareconomy.brussels/over/faq/?lang=nl/\n\n3. De online helpdesk op het kandidatuurplatform beantwoordt schriftelijk alle vragen: https://www.mycirculareconomy.brussels/support\n\nWij feliciteren u nogmaals met uw inzet en wensen u, mevrouw, mijnheer, het allerbeste toe.`,
      rejected:
        `Geachte heer of mevrouw,\n\nHartelijk dank voor het indienen van uw kandidatuur voor de eerste ronde van de "Be Circular - Be Brussels ${APP_YEAR}"-projectoproep. De circulaire economie begint wortel te schieten in het Brusselse gewest en aan ideeën ontbreekt het de bedrijven geenszins, zoals blijkt uit het aantal aanvragen dat voor de eerste ronde van deze nieuwe editie is ontvangen. In totaal werden 131 dossiers ingediend door ondernemingen, zelfstandigen of verenigingen uit de Brusselse economische wereld.\n\nAlle aanvragen zijn geanalyseerd door een jury bestaande uit de drie overheidsdiensten die de projectoproep coördineren. De jury stelde een ranglijst op en aangezien Be Circular een wedstrijd is, werden alleen de beste kandidaturen in volgorde van rangschikking voorgeselecteerd. \n\nTot onze spijt moeten wij u mededelen dat uw project aan het eind van de eerste kandituren ronde niet tot de voorgeselecteerde projecten behoorde. Hieronder vindt u een samenvatting van de analyse die de Be Circular-jury van uw kandidatuur heeft gemaakt.\n\nWij herinneren eraan dat de Be Circular-projectoproep slechts een van de vele Brusselse steunen voor economische transitie is. Blader gerust eens door het volledige aanbod aan steun voor de circulaire economie in het Brussels Hoofdstedelijk Gewest: https://www.circulareconomy.brussels/offre-de-soutien-a-leconomie-circulaire/?lang=nl\n\nWe zijn verheugd over uw belangstelling en uw proactieve aanpak in de overgang naar een circulaire economie, en we hopen uw belangstelling opnieuw te kunnen wekken bij de volgende BeCircular-projectoproep begin ${APP_YEAR + 1}.\n\n`,
      // NYD: 'Betreft: kandidaatstelling Be Circular 2021: verzoek om bijkomende informatie\n\nGeachte mevrouw, geachte heer,\n\nWij danken u voor uw deelname aan de projectoproep "Be Circular – Be Brussels 2021".\n\nNa een eerste administratieve analyse van uw kandidaatstelling blijkt uw aanvraag onvolledig / nog niet in orde te zijn. Volgende documenten ontbreken immers:\n\n1.\n\n2.\n\nTegen woensdag 26 mei 2021 zouden wij voor het middaguur de ontbrekende / verbeterde documenten van u moeten ontvangen via het platform voor kandidaatstelling.\n\nVoor alle bijkomende inlichtingen kan u bij ons terecht.\n\nMet vriendelijke groeten,\n\n\n\nHet team Be Circular – Be Brussels ',
    },
  };

  const handleChangeSubmission = ({ target }) => {
    const { name, value } = target;

    setSubmission((prev) => {
      // let message = name === 'result' ? defaultMessage[props.lang][value] : prev.message;
      let subject = name === 'result' ? subjects[props.lang ?? 'fr'][value] : prev.subject;

      return {
        ...prev,
        // message: message,
        subject: subject,
        [name]: value,
      };
    });
  };

  const generateMessage = () => {
    const lang = props.lang ?? 'fr';

    let message;

    if (evaluationParameters.emailTemplates && evaluationParameters.emailTemplates[submission.result] && evaluationParameters.emailTemplates[submission.result][lang]) {
      message = evaluationParameters.emailTemplates[submission.result][lang]
    }
    else {
      message = defaultMessage[lang][submission.result];
    }

    message = (message || '') + '\n\n\n'


    if (lang === 'fr') {
      message += 'Synthèse de l’analyse de votre dossier de candidature (1er tour) par le jury BeCircular :\n\n';
    }
    if (lang === 'nl') {
      message += 'Samenvatting van de analyse van uw kandidatuur (1ste ronde) door de BeCircular-jury:\n\n';
    }

    if (props.administrativeReview && props.administrativeReview.status === 'reviewed' && props.administrativeReview.flag === props.evaluationFlag) {
      if (lang === 'fr') {
        message += 'Eligibilité administrative du dossier\n';
      } else if (lang === 'nl') {
        message += 'Ontvankelijkheid van de dossier\n';
      }
      if (props.administrativeReview.result === "accepted") {
        message += lang === 'fr' ? 'Conforme\n' : 'Ontvankelijk\n';
      } else if (props.administrativeReview.result === 'rejected') {
        message += lang === "fr" ? 'Non conforme:\n' : 'Niet ontvankelijk\n';
        message += props.administrativeReview.message + '\n';
      } else if (props.administrativeReview.result === 'warning') {
        message += lang === 'fr' ? 'ATTENTION:\n' : 'PAS OP ';
        message += props.administrativeReview.message + '\n';
      }
      message += '\n';
    }

    // if (props.administrativeReview)
    // message +=

    props.evaluationQuestions.forEach((q) => {
      if (q.conditional) {
        const field = q.conditional.field || '';
        const value = q.conditional.value || [];
        const projectEntry = q.conditional.status_field ? props.projectData.status : props.projectData.data;

        if (!(field in projectEntry)) return;

        if (!value.includes(projectEntry[field])) return;
      }

      let title = `${q.short_title[lang]}\n`;
      title = title
        .replace('<br/>', '')
        .replace(/(<span[\w\W]+\/span>)/gi, '')
        .replace(/(<a[\w\W]+\/a>)/gi, '');

      message += title;

      if (q.eval_type === 'boolean') {
        if (lang === 'fr') {
          message += props.evaluationState[q.name] ? 'Conforme' : 'Non conforme';
        } else if (lang === 'nl') {
          message += props.evaluationState[q.name] ? 'Ontvankelijk' : 'Niet ontvankelijk';
        }
        message += '\n';
      }
      message += `${props.evaluationState[q.name + '_justification']}\n`;
      if (props.evaluationState[q.name + '_recommandation']) {
        message += `\n`;
        if (lang === 'fr') {
          message += `Recommandation:`;
        } else if (lang === 'nl') {
          message += `Aanbevelingen:`;
        }
        message += `\n`;
        message += `${props.evaluationState[q.name + '_recommandation']}\n`;
      }
      message += '\n\n';
    });

    setSubmission((prev) => {
      return {
        ...prev,
        message: message,
      };
    });
  };

  return (
    <Container component="div" maxWidth={false} className={submissionStyle.checkContent + ' ' + submissionStyle.submitContainer}>
      <Box>
        <Typography variant="h6" style={{ marginBottom: 10 }}>
          Cloturer la candidature
        </Typography>

        {props.lang === 'nl' && (
          <Box sx={{ mt: 2, mb: 2 }}>
            <Box component="span" sx={{ verticalAlign: 'middle' }}>
              <GppMaybeIcon color="error" />
            </Box>
            <Box component="span" sx={{ verticalAlign: 'middle' }}>
              <strong className="red"> Attention: le projet a été soumis en Néerlandais!</strong>
            </Box>
          </Box>
        )}

        <p className={submissionStyle.inlineElement}>Quel statût voulez-vous donner à la candidature</p>
        <FormControl variant="outlined" className={submissionStyle.formControl}>
          <Select disabled={props.submittingEvaluation} value={submission.result} name="result" onChange={handleChangeSubmission} inputProps={{ 'aria-label': 'Without label' }}>
            <MenuItem value="accepted">Accepté</MenuItem>
            <MenuItem value="rejected">Rejeté</MenuItem>
            {/* <MenuItem value="NYD">En attente (ré-ouvre le projet du soumissionnaire)</MenuItem> */}
          </Select>
        </FormControl>
      </Box>

      {submission.result !== '' && evaluationParameters.sendEmail && evaluationParameters.sendEmail.includes(submission.result) && (
        <>
          <Button disabled={props.submittingEvaluation} sx={{ mb: 2 }} variant="contained" className={`${submissionStyle.closeButton} button-blue`} onClick={generateMessage}>
            Générer un message pour candidat
          </Button>
          <Box>
            {/* className={classes.commentBox + ' ' + (submission.result !== '' ? classes.showCommentBox : '')} */}

            <p> Ce message sera envoyé au candidat (vous pouvez le modifier)</p>
            {/* <p> Ce message sera envoyé au soumissionaire (vous pouvez le modifier)</p> */}
            <p>
              Sujet: <em>{submission.subject}</em>
            </p>
            <TextField
              disabled={props.submittingEvaluation}
              name="message"
              onChange={handleChangeSubmission}
              value={submission.message}
              placeholder="Remplissez un message"
              variant="outlined"
              multiline={true}
              rows={8}
              fullWidth={true}
            />
          </Box>
        </>
      )}

      <div className={submissionStyle.closeContainer}>
        <Button
          variant="contained"
          className={`${submissionStyle.closeButton} button-${submission.result}`}
          disabled={
            props.submittingEvaluation || submission.result === '' || (evaluationParameters.sendEmail && evaluationParameters.sendEmail.includes(submission.result) && submission.message === '')
          }
          onClick={closeReview}
        >
          Cloturer l'évalation : {submission.result === 'accepted' && 'Accepté'}
          {submission.result === 'rejected' && 'Rejeté'}
          {/* {submission.result === 0 && 'Attention'} */}
        </Button>
      </div>
    </Container>
  );
};
